/**
 * GrainOverlay — SVG feTurbulence noise for material premium feel.
 *
 * Canon v4 раздел 7: «Grain noise на phone-scroll — SVG feTurbulence overlay
 * alpha 0.025, mix-blend-mode overlay, position absolute (внутри phone
 * scroll контейнера, не fixed). Material premium вместо plastic-flat.»
 *
 * Render inside any scroll container as the first child; the overlay
 * is pointer-events:none and absolutely positioned to fill its parent.
 *
 * Tradeoffs:
 *   • SVG feTurbulence has good GPU acceleration on Chromium / WebKit
 *   • alpha 0.025 keeps it imperceptible on light glance but adds
 *     surface texture which kills the "matte plastic" feel
 *   • mix-blend-mode overlay tints with underlying surface; works
 *     on canon bg-0 / bg-1 without muddying type contrast
 */
import { useId } from "react";

export interface GrainOverlayProps {
  /** Override opacity. Default 0.025 (canon). Useful 0.015–0.04. */
  opacity?: number;
  /** Base frequency for feTurbulence. Higher = finer grain. */
  baseFrequency?: number;
  /** Number of octaves — higher = more detail. */
  numOctaves?: number;
  /** Skip rendering entirely (e.g. when user prefers reduced motion). */
  disabled?: boolean;
  testId?: string;
}

export function GrainOverlay({
  opacity = 0.025,
  baseFrequency = 0.9,
  numOctaves = 2,
  disabled = false,
  testId = "grain-overlay",
}: GrainOverlayProps) {
  const filterId = useId();
  if (disabled) return null;
  return (
    <svg
      data-testid={testId}
      aria-hidden="true"
      className="pointer-events-none absolute inset-0 w-full h-full"
      style={{
        opacity,
        mixBlendMode: "overlay",
        zIndex: 0,
      }}
    >
      <filter id={`grain-${filterId}`}>
        <feTurbulence
          type="fractalNoise"
          baseFrequency={baseFrequency}
          numOctaves={numOctaves}
          stitchTiles="stitch"
        />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 1   0 0 0 0 1   0 0 0 0 1   0 0 0 1 0"
        />
      </filter>
      <rect width="100%" height="100%" filter={`url(#grain-${filterId})`} />
    </svg>
  );
}
